import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["eventId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import api from 'utils/api';
import { eventSessionsQueryKeys } from 'actions/eventSessions';
import { assetQueryKeys } from 'actions/assets';
import { setAlert, setSuccessAlert } from 'actions/alerts';
function useDeleteEventSession(_ref) {
  var eventId = _ref.eventId,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function deleteSession(_x) {
    return _deleteSession.apply(this, arguments);
  }
  function _deleteSession() {
    _deleteSession = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var sessionId;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            sessionId = _ref2.sessionId;
            if (config.eventAssets) {
              _context2.next = 1;
              break;
            }
            throw new Error('Event assets are not enabled');
          case 1:
            return _context2.abrupt("return", api('delete', "/api/assets/".concat(eventId, "/sessions/").concat(sessionId)));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _deleteSession.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: deleteSession
    }, options), {}, {
      onError: function onError(error, variables, onMutateResult, context) {
        var _options$onError;
        setAlert({
          title: t('alert_delete_session_error')
        });
        return (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, error, variables, onMutateResult, context);
      },
      onSuccess: function () {
        var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, variables, onMutateResult, context) {
          var _options$onSuccess;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return Promise.all([queryClient.invalidateQueries({
                  queryKey: eventSessionsQueryKeys.eventSessions
                }), queryClient.invalidateQueries({
                  queryKey: assetQueryKeys.singleAsset(eventId)
                })]);
              case 1:
                setSuccessAlert({
                  title: t('alert_delete_session_success')
                });
                return _context.abrupt("return", (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 ? void 0 : _options$onSuccess.call(options, data, variables, onMutateResult, context));
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onSuccess(_x2, _x3, _x4, _x5) {
          return _onSuccess.apply(this, arguments);
        }
        return onSuccess;
      }()
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    deleteSession: mutateAsync
  });
}
export default useDeleteEventSession;